// Auto-generated by `pnpm tl`. Do not edit by hand.
// Source: backend ExtractionErrorCategoryRegistry.All — served from /api/v1/error-categories.
import { ExtractionErrorCategory } from './generated-types';

export interface ExtractionErrorCategoryMetadata {
  category: ExtractionErrorCategory;
  summary: string;
  userMessage: string;
  retryable: boolean;
  reportable: boolean;
}

export const ERROR_CATEGORY_CATALOGUE: Readonly<Record<ExtractionErrorCategory, ExtractionErrorCategoryMetadata>> = {
  [ExtractionErrorCategory.DcmColumnHeaderNotFound]: {
    category: ExtractionErrorCategory.DcmColumnHeaderNotFound,
    summary: 'DCM RTF did not contain the expected column header — file may be wrong type or template changed.',
    userMessage: 'We couldn\'t recognise this RTF as a Dangerous Cargo Manifest. Please verify the file.',
    retryable: false,
    reportable: true,
  },
  [ExtractionErrorCategory.DcmParseFailure]: {
    category: ExtractionErrorCategory.DcmParseFailure,
    summary: 'DCM chunks parsed but produced no usable cargo data — parser regression or unexpected manifest format.',
    userMessage: 'We couldn\'t extract cargo from this manifest. Please contact support if this persists.',
    retryable: false,
    reportable: true,
  },
  [ExtractionErrorCategory.DgdGeminiError]: {
    category: ExtractionErrorCategory.DgdGeminiError,
    summary: 'Gemini AI service returned an error.',
    userMessage: 'The AI extraction service encountered an error.',
    retryable: true,
    reportable: true,
  },
  [ExtractionErrorCategory.DgdPdfLowResolution]: {
    category: ExtractionErrorCategory.DgdPdfLowResolution,
    summary: 'Every page is a bitmap below the resolution the model can read. Usually a screenshot pasted into a document and stretched to fill the page.',
    userMessage: 'The pages are low-resolution images. Upload the original file, or a scan of at least 200 DPI.',
    retryable: false,
    reportable: true,
  },
  [ExtractionErrorCategory.DgdZeroCargo]: {
    category: ExtractionErrorCategory.DgdZeroCargo,
    summary: 'DGD extraction returned zero cargo after retries.',
    userMessage: 'No cargo could be read from this dangerous goods declaration. Please check the document, or contact support if this persists.',
    retryable: false,
    reportable: true,
  },
  [ExtractionErrorCategory.DgdOutputTruncated]: {
    category: ExtractionErrorCategory.DgdOutputTruncated,
    summary: 'The model hit its output token cap and the pages could not be split any smaller.',
    userMessage: 'This document is too long for the model to return in one answer. Try extracting it in smaller sections.',
    retryable: false,
    reportable: true,
  },
  [ExtractionErrorCategory.DgdParseFailure]: {
    category: ExtractionErrorCategory.DgdParseFailure,
    summary: 'Extraction ran but the model output could not be parsed into a document.',
    userMessage: 'The document could not be read.',
    retryable: true,
    reportable: true,
  },
  [ExtractionErrorCategory.DgdPdfUnreadable]: {
    category: ExtractionErrorCategory.DgdPdfUnreadable,
    summary: 'Neither the splitting nor the rendering engine could open the file. Structurally damaged.',
    userMessage: 'We couldn\'t open this PDF. The file looks damaged, so re-extracting will not help.',
    retryable: false,
    reportable: true,
  },
  [ExtractionErrorCategory.ServiceBusy]: {
    category: ExtractionErrorCategory.ServiceBusy,
    summary: 'Upstream AI service signalled temporary overload.',
    userMessage: 'The service is temporarily overloaded. Please try again shortly.',
    retryable: true,
    reportable: true,
  },
  [ExtractionErrorCategory.Timeout]: {
    category: ExtractionErrorCategory.Timeout,
    summary: 'Extraction did not complete within the configured timeout.',
    userMessage: 'The extraction took too long. Try a simpler extraction method or a smaller page range.',
    retryable: true,
    reportable: true,
  },
  [ExtractionErrorCategory.Unknown]: {
    category: ExtractionErrorCategory.Unknown,
    summary: 'Uncategorised extraction failure.',
    userMessage: 'An error occurred while processing the document.',
    retryable: false,
    reportable: true,
  },
};
